import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { REQUEST_SMS_TIMER } from '../constants';
import { SmsRequestTimerProps } from '../interface';

export default observer((props: SmsRequestTimerProps) => {
  const {
    onTimerEnd,
    timeoutThreshold = REQUEST_SMS_TIMER,
    resetTimer,
  } = props;
  const { t } = useTranslation();
  const [seconds, setSeconds] = useState(timeoutThreshold);

  useEffect(() => {
    if (resetTimer) {
      setSeconds(timeoutThreshold);
    }
  }, [resetTimer, timeoutThreshold]);

  useEffect(() => {
    if (seconds <= 0) {
      return;
    }
    const timeout = setTimeout(() => {
      const secondsLeft = seconds - 1;
      if (secondsLeft <= 0) {
        onTimerEnd();
        setSeconds(0);
        return;
      }
      setSeconds(secondsLeft);
    }, 1000);
    return () => clearTimeout(timeout);
  }, [seconds, onTimerEnd]);

  if (seconds <= 0) {
    return <>{t('phrases:resendCodeAgain', { time: '' })}</>;
  }

  const formattedSeconds = seconds.toString().padStart(2, '0');
  return (
    <>{t('phrases:resendCodeAgain', { time: `00:${formattedSeconds}` })}</>
  );
});
